module.exports = __webpack_public_path__ + "static/media/instructor1.61a64fa8.png";